module.exports = __webpack_public_path__ + "static/pivonuv-beh-2021-05-21d70d9917de67da9c89e26acd1d6a83.jpg";